import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail, MapPin, ChevronRight } from "lucide-react";
import { LOGO_URL, COMPANY } from "../mock";

const Footer = () => {
  const links = [
    { label: "Home", path: "/" },
    { label: "Cars for sale", path: "/cars-for-sale" },
    { label: "Motorcycles For Sale", path: "/motorcycles" },
    { label: "Our Services", path: "/services" },
    { label: "Car Sourcing", path: "/car-sourcing" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <footer className="gpm-bg-green-dark gpm-text-cream mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <h4 className="font-serif-display text-2xl mb-4">Get in touch</h4>
          <div className="gpm-divider mb-6" />
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3"><Phone size={16} className="gpm-text-gold mt-0.5" /> <a href={`tel:${COMPANY.phone}`} className="hover:gpm-text-gold transition-colors">{COMPANY.phone}</a></li>
            <li className="flex items-start gap-3"><Mail size={16} className="gpm-text-gold mt-0.5" /> <a href={`mailto:${COMPANY.email}`} className="hover:gpm-text-gold transition-colors">{COMPANY.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="gpm-text-gold mt-0.5" /> <span className="opacity-90">{COMPANY.address}</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-2xl mb-4">Useful Links</h4>
          <div className="gpm-divider mb-6" />
          <ul className="space-y-3 text-sm">
            {links.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="flex items-center gap-2 opacity-90 hover:gpm-text-gold hover:opacity-100 transition-colors">
                  <ChevronRight size={14} className="gpm-text-gold" /> {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-2xl mb-4">Find Us</h4>
          <div className="gpm-divider mb-6" />
          <ul className="space-y-3 text-sm">
            <li><a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 opacity-90 hover:gpm-text-gold transition-colors"><Facebook size={16} className="gpm-text-gold" /> Facebook</a></li>
            <li><a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 opacity-90 hover:gpm-text-gold transition-colors"><Instagram size={16} className="gpm-text-gold" /> Instagram</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-2xl mb-4">Looking for a car?</h4>
          <div className="gpm-divider mb-6" />
          <p className="text-sm opacity-90 mb-5">Browse our curated collection of the finest classic and modern classic motorcars.</p>
          <Link
            to="/cars-for-sale"
            className="inline-flex items-center gap-2 gpm-text-green px-6 py-3 text-sm font-semibold tracking-wide uppercase transition-transform hover:-translate-y-0.5"
            style={{ backgroundColor: "var(--gpm-cream)" }}
          >
            View all cars <ChevronRight size={16} />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs opacity-70">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="GPM" className="h-8 w-8 object-contain rounded-full" />
            <span>&copy; {new Date().getFullYear()} GPM Classics. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4">
            <span>Established purveyors of fine classic motorcars.</span>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="opacity-70 hover:gpm-text-gold hover:opacity-100 transition-colors">Privacy Policy</Link>
            <Link to="/terms-conditions" data-testid="footer-terms-link" className="opacity-70 hover:gpm-text-gold hover:opacity-100 transition-colors">Terms &amp; Conditions</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="opacity-70 hover:gpm-text-gold hover:opacity-100 transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
